export default __webpack_public_path__ + "static/media/step3.24eb3c09.svg";